import { setSpecificMessage, base64 } from "valibot";
setSpecificMessage(
  base64,
  (issue) => `Base64 invalide: reçu ${issue.received}`,
  "fr"
);